import { useState , useEffect } from 'react';
import { priceFormat } from 'util/prices';
import Barcode from 'react-barcode';
import { BASE_PATH_API } from 'constants/env';
import { decodeStorage } from 'functions/storageBase64';
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'
import { hash256 } from 'functions/hash256';
import styles from './styles.module.sass'


const WalletComponent = (props) => {

    const {
        monedero,
        eventWallet,
        setEdosCuenta,
        setHashToken,
        setSaldoActual
    } = props

    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    const [ walletService, setWalletService ]= useState(null)
    const accessToken = `Bearer ${ decodeStorage('access_token') }`

    const getWalletData = async (eventID) => {
        dispatch(showLoader());
        const idsFilter = String(eventID)
        try {
            const header = {
                headers: { 'Authorization': accessToken }
            }
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/electronic-wallet/${idsFilter}`, header);
            const data = await response.json();
            setWalletService(data?.data)
        } catch (error) {
            dispatch(hideLoader());
            console.error('Error fetching getEventTable data:', error);
        }
    }

    const [ dataWallet, setDataWallet ] = useState([])

    useEffect(()=>{
        if(monedero?.data){
            setDataWallet(monedero?.data)
            setHashToken(hash256(monedero?.data[0]?.Monedero))
        }
    },[monedero])

    useEffect(()=>{
        if(eventWallet?.wallet_id){
            const idWallet = eventWallet?.wallet_id
            getWalletData(idWallet)
        }
    },[eventWallet])

    const [ transactions, setTransactions ] = useState([])
    const [ totalAmount, setTotalAmount ] = useState('$0')
    const [ dispAmount, setDispAmount ] = useState('$0')
    useEffect(()=>{
        if(walletService){
            dispatch(hideLoader());
            setTransactions(walletService?.transactions)
            const totalAmountA = walletService?.total_amount
            const currentAmountA = walletService?.current_amount
            let current; let total
            
            if( isNaN(currentAmountA) ){
                current = currentAmountA
            }else{
                current = `$${priceFormat( Number(currentAmountA) ) }`
            }

            if( isNaN(totalAmountA) ){
                total = totalAmountA
            }else{
                total = `$${priceFormat( Number(totalAmountA) ) }`
            }

            setTotalAmount(total)
            setDispAmount(current)
            setSaldoActual(current)
        }
    },[walletService])

    const getMouvements = () => {
        setEdosCuenta(true)
    }

    return(
        <>
            <div>
                <div className={styles?.contCardsAmounts}>
                    <p>Total transferido a monedero:</p> 
                    <span>{ totalAmount }</span>
                </div>

                <div className={styles?.contCardsAmounts}>
                    <p>Saldo actual disponible:</p>
                    <span>{ dispAmount }</span>      
                </div>

                <div className={`${styles?.contCardsAmounts} ${styles?.next}`} aria-hidden onClick={getMouvements}>
                    <p>Compras con mi monedero:</p>    
                </div>
            </div>

            <div className={styles?.contCardsWallets}>
                {
                    dataWallet?.map(wallets => (
                        <div>
                            <Barcode displayValue={false} value={wallets?.Monedero} />
                            <p>{wallets?.Monedero}</p>
                        </div>
                    ))
                }
            </div>
            
            <div className={styles?.contTableMouvements}>
                {transactions?.length >= 1
                    ?
                        <>
                            <h2 className={styles?.subTitmes}>Detalle de movimientos</h2>

                            {
                                transactions?.map(transaction => (
                                    <div className={styles?.contMouvements}>
                                        <p className={styles?.space1}>{transaction?.description}</p>
                                        <p className={styles?.space2}>${priceFormat(transaction?.amount)}</p>
                                        <p className={styles?.space3}>{transaction?.transaction_date}</p>
                                        <p className={styles?.montoT}>Monto transferido</p>
                                    </div>
                                ))
                            }
                        </>
                    : null    
                }
            </div>
        </>
    )
}

export default WalletComponent